var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:['span-arrow', _vm.autoClass, _vm.clasSpan, ( _obj = {}, _obj[_vm.classSpan] = true, _obj )]})}
var staticRenderFns = []

export { render, staticRenderFns }